// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from '@/store'
// import { i18n } from '@/lang/i18n'
// import Rollbar from 'rollbar'
import VueI18n from 'vue-i18n'
import messages from '@/lang/lang.js'

import 'babel-polyfill'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@/assets/scss/style.scss'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-datetime/dist/vue-datetime.css'

Vue.config.productionTip = false

/* Vue.prototype.$rollbar = new Rollbar({
  accessToken: 'cc0e39e85ab8407aac4814a5aad398a9',
  captureUncaught: true,
  captureUnhandledRejections: true,
  reportLevel: 'error',
  enabled: process.env.NODE_ENV !== 'development'
})

Vue.config.errorHandler = (err, vm, info) => {
  vm.$rollbar.error(err)
  throw err // rethrow
} */

// update the user token
setInterval(function () {
  if (store.state.authStore.token.auth_token !== undefined) {
    store.dispatch('authStore/login', {pin: store.state.authStore.token.pin}, { root: true })
  }
}, 3600000)

store.dispatch('menus/populateState')
store.dispatch('products/searchCourseSpliterProduct')
store.dispatch('authStore/logout')

Vue.filter('formatDateTime', function (value) {
  if (!value) return ''
  let date = null
  let time = null

  value = value.split('T')
  date = value[0] ? value[0] : null
  time = value[1] ? value[1] : null

  // Format date
  if (date === null) {
    return ''
  }

  date = date.split('-')

  // Format time
  if (time === null) {
    return ''
  }

  time = time.split(':')

  return date[2] + '/' + date[1] + '/' + date[0] + ' ' + time[0] + ':' + time[1]
})

Vue.filter('formatDate', function (value) {
  if (!value) return ''
  let date = null

  date = value.split('-')

  return date[2] + '/' + date[1] + '/' + date[0]
})

Vue.filter('formatTime', function (value) {
  if (!value) return ''
  let time = null

  time = value.split(':')

  return time[0] + ':' + time[1]
})

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'sq',
  messages
})

// set default language
i18n.locale = 'sq'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js